import React from 'react';
import loadingLogo from '../assets/tendera_logo_loading.png'; // Adjust path if needed

const LoadingScreen = () => {
    return (
        <div style={{
            height: '100vh',
            width: '100vw',
            backgroundColor: '#282c34',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            color: '#ff670e',
            fontSize: '1.5rem',
            fontFamily: 'sans-serif',
            animation: 'fadeIn 1s ease-in-out'
        }}>
            <img
                src={loadingLogo}
                alt="Loading Logo"
                style={{
                    width: '60px',
                    height: '60px',
                    animation: 'spin 1.5s ease-in-out infinite',
                    marginBottom: '1rem'
                }}
            />
            Loading...
            <style>
                {`
                    @keyframes spin {
                        0% { transform: rotate(0deg); }
                        100% { transform: rotate(-360deg); }
                    }

                    @keyframes fadeIn {
                        from { opacity: 0; }
                        to { opacity: 1; }
                    }
                `}
            </style>
        </div>
    );
};

export default LoadingScreen;
